import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=5135d50e&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=5135d50e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_5d87ee476163469805fc3ac1400a87b6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135d50e",
  null
  
)

export default component.exports